'use client';

import { observer } from 'mobx-react';
import { ZipcodePagination } from '~/definitions/zipcode';
import { getStore } from '~/mobx/AppStore';

interface PaginationProps {
    pagination: ZipcodePagination[];
    onRangeClick: (pageName: string, index: number) => void;
    isGettingZipcode: boolean;
    zipcodeList: string[];
}

const Pagination = (props: PaginationProps) => {
    const renderPageList = () => {
        const pageList: JSX.Element[] = [];
        const countPage = props.pagination?.length || 0;

        props.pagination?.forEach((page, index) => {
            const classNamesDefault = `no-underline relative text-[#555555] visited:text-[#555555]`;
            const classNamesActive = `cursor-pointer`;
            const classNamesPage = [classNamesDefault, classNamesActive];
            const formattedName = page.name.replace(/-/, ' - ');

            pageList.push(
                <span key={`pagination-${index}`}>
                    {page?.active ? (
                        <span className="font-bold">{formattedName}</span>
                    ) : (
                        <a
                            href="/"
                            key={`filter-${index}`}
                            className={classNamesPage.join(' ')}
                            onClick={(e) => {
                                e.preventDefault();
                                props.onRangeClick(page.name, page.page);
                            }}
                        >
                            {formattedName}
                        </a>
                    )}
                    {index === countPage - 1 ? '' : ' | '}
                </span>
            );
        });

        return pageList;
    };

    const shouldRenderZipcodePagination = !props.isGettingZipcode && props.zipcodeList.length > 0;

    return (
        <div className="overflow-x-auto mb-4">Fra - Til: {shouldRenderZipcodePagination ? renderPageList() : '-'}</div>
    );
};

const PaginationWithStore = () => {
    const { zipcodeStore } = getStore();

    const onClick = (pageName: string, pageNumber: number) => {
        const id = pageName.replace(/\s+/g, '');
        zipcodeStore.setSelectedRangeId(id);

        const updatedPages = zipcodeStore.paginationData.map((item) => ({
            ...item,
            active: item.page === pageNumber,
        }));

        zipcodeStore.setPaginationData(updatedPages);
        zipcodeStore.setSelectedRangeId(pageName);
        zipcodeStore.getZipcodeList();
        zipcodeStore.setZipCodesToDelete([]);
    };

    return (
        <Pagination
            pagination={zipcodeStore.paginationData}
            onRangeClick={onClick}
            isGettingZipcode={zipcodeStore.isGettingZipcode}
            zipcodeList={zipcodeStore.zipcodeList}
        />
    );
};

export default observer(PaginationWithStore);
